export const RoundDecimalNumber = (value: number, decimal: number) => {
  const og = Math.pow(10, decimal);
  return Math.round(value * og) / og;
}